import axios from 'axios';
import { signOutService } from './AuthService';
import SessionStorageService from "./SessionStorageService";
import GlobalLoadingActions from '../stores/GlobalLoading/Actions';

let store

export const injectStore = _store => {
    store = _store
}

const apiServiceCall = (disbleGlobalLoading) => {
    const axiosInstance = axios.create();
    axiosInstance.interceptors.request.use(
        async config => {
            if(config.method === 'post' || config.method === 'delete' || config.method === 'put'){
                if(!disbleGlobalLoading){
                    store.dispatch(GlobalLoadingActions.showGlobalLoading())
                }
            }
            let Token = 'F3J92ND9J5@493SBMDJW1344JEUDJ3TES3I/3'
            config.baseURL = process.env.REACT_APP_BACKEND_URL
            config.headers = {
                'x-token': Token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...config.headers,
            }
            return config;
        },
        error => {
            Promise.reject(error)
        });

    axiosInstance.interceptors.response.use(async (response) => {
            store.dispatch(GlobalLoadingActions.hideGlobalLoading())
        /*  const originalRequest = response.config;
         if (response.data?.msg === 'El token ha expirado' && !originalRequest._retry) {
             originalRequest._retry = true;
             const access_token = await refreshToken();
             axiosInstance.defaults.headers.common['Authorization'] = 'beater ' + access_token;
             return axiosInstance(originalRequest);
         } */
        return response
    }, async function (error) {
        store.dispatch(GlobalLoadingActions.hideGlobalLoading())
        return Promise.reject(error);
    });
    return axiosInstance;
}

/* const refreshToken = async () => {
    try {
        let response = await apiServiceCall().get('/refresh/token');
        if (response.data.success) {
            SessionStorageService.setItem('token', response.data.payload.token);
            return response.data.payload.token;
        } else {
            //if token cant be refreshed logOut
            signOutService();
            return null;
        }
    } catch (error) {
        //if token cant be refreshed logOut
        signOutService();
        return null;
    }

} */

export default apiServiceCall;